import React, { Component } from 'react';
import { openPopupWindow } from '../../util';
import { MODAL_USER_NOT_LOGGED_IN } from '../../util/enums/EnumModals';

class UserNotLoggedInModal extends Component {
  static modalType() {
    return MODAL_USER_NOT_LOGGED_IN;
  }

  static reducer() {
    return null;
  }

  static title() {
    return 'Session expired';
  }

  render() {
    function reAuthenticate(e) {
      e.preventDefault();
      const url = `${window.location.pathname}?reAuth=true`;
      const title = 'Re-authenticating user...';
      openPopupWindow(url, title, 500, 500);
      // onModalHidden();//note: modal is actually hidden by the data-bs-dismiss="modal" property
    }
    function refreshPage() {
      window.location.reload();
    }
    return (
      <div>
        <h5>You have been logged out.</h5>
        <button
          type="button"
          className="btn btn-primary"
          data-bs-dismiss="modal"
          onClick={refreshPage}
        >
          Refresh page
        </button>
        &nbsp;or{' '}
        <a href="#" data-bs-dismiss="modal" onClick={reAuthenticate}>
          Re-authenticate
        </a>
      </div>
    );
  }
}

export default UserNotLoggedInModal;
